module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/eyecatch-campaign-1-fabfc344de689e2c17705f0d1a409caf.svg";